import { ClassProvider, Injectable, InjectionToken, Type, inject } from '@angular/core';
import { IApiOption } from '@red/api';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DynamicReportGeneralModel } from './dynamic-report-general.model';
import { PaginationAdapter } from '@red/data-access';
import { ExceljsCard, ExceljsWorkBook } from '@shared/components/exceljs-viewer';
import { DynamicReportGeneralDto, PreviewDynamicReportDto } from './dynamic-report-general.dto';
export const DYNAMIC_REPORT_HTTP_LOADER = new InjectionToken<DynamicReportHttpLoader>('DYNAMIC_REPORT_HTTP_LOADER');
export const DYNAMIC_REPORT_CARD = new InjectionToken<ExceljsCard>('DYNAMIC_REPORT_CARD');


@Injectable()
export abstract class DynamicReportHttpLoader {
  /**
 * search
 *
 * @param query: object
 * @param option
 */
  abstract search(query: {}, option?: IApiOption): Observable<PaginationAdapter<DynamicReportGeneralModel>>;

  /**
   * getById
   *
   * @param id: string
   */
  abstract getById(id: number): Observable<DynamicReportGeneralModel>;

  /**
 * getMeta
 *
 * @param type: string
 */
  abstract getMeta(type: string): Observable<DynamicReportGeneralModel>;

  /**
* createPreview
*
 * @param id
 * @param data
*/
  abstract createPreview(id: number, data?: PreviewDynamicReportDto): Observable<ExceljsWorkBook>;

  /**
 * create
 *
 * @param data
 */
  abstract create(data: DynamicReportGeneralDto): Observable<DynamicReportGeneralModel>;

  /**
* update
* @param id
* @param data
*/
  abstract update(id: number, data: DynamicReportGeneralDto): Observable<DynamicReportGeneralModel>;

  /**
* delete
*
* @param id
* @param type
  */
  abstract delete(id: number): Observable<any>;
  /**
   * export
   *
   * @param type: string
   * @param data
   */
  abstract export(id: number, data: DynamicReportGeneralDto): Observable<any>;
  /**
   * get data by query
   * Using for template
   */
  get(method: 'get' | 'post', endpoint: string, query: HttpParams | any): Observable<any> {
    const httpClient = inject(HttpClient);
    const payload = this.normalizeOption(method, endpoint, query);
    return httpClient.request(payload.method, payload.url, payload.options);
  }

  normalizeOption(method: string, endpoint: string, query: HttpParams) {
    const responseType: 'json' | 'arraybuffer' | 'blob' | 'text' = 'json';
    return {
      method,
      url: this.createAPIURL(endpoint, query),
      options: {
        params: query,
        responseType,
      },
    };
  }

  createAPIURL(url: string, params: HttpParams | any): string {
    const paths = url.split('/');
    paths.forEach((path, i) => {
      if (path.startsWith(':')) {
        const key = path.slice(1);
        if (typeof params[key] !== 'object') {
          paths[i] = String(params[key]);
          delete params[key];
        }
      }
    });

    return paths.join('/');
  }
}

export const useDynamicReportLoader = (instance: Type<DynamicReportHttpLoader>): ClassProvider => ({
  provide: DYNAMIC_REPORT_HTTP_LOADER,
  useClass: instance,
  multi: false,
});
